import React from 'react';
import PropTypes from 'prop-types';

function InputLabel({
    label,
    text,
})
{
    return (
        <div>
            <label className="tw-font-bold tw-text-sm tw-mr-1">{label}</label>
            <div className="tw-text-sm tw-block tw-text-base">{text}</div>
        </div>
    );
}

InputLabel.propTypes = {
    text: PropTypes.node,
    label: PropTypes.string.isRequired,
};

export default InputLabel;
